// extracted by mini-css-extract-plugin
module.exports = {"blockClick":"TemplateListEmail_blockClick_8mfif"};